import React, { useEffect, useRef, useState } from 'react';
import classNames from 'clsx';

import CarouselButtons from './CarouselButtons';
import Helpers from '../../utils/Helpers';
import { useApplicationParams, useLanguage } from '../../context';

const FreeCarousel = ({
  ItemComponent,
  data,
  itemsToShow = 2,
  showHalfOfNext = false,
  showDots = false,
  sectionId,
  minCount,
  childCount,
}) => {
  const ref = useRef(null);

  const { isWeb } = useApplicationParams();
  const { isRtl } = useLanguage();

  const isMobile = Helpers.getIsMobile();
  const isTablet = Helpers.getIsTablet();

  const el = document.getElementById(sectionId);
  const elScrollLeft = el?.scrollLeft;
  const elScrollWidth = el?.scrollWidth;
  const elOffsetWidth = el?.offsetWidth;

  const [scroll, setScroll] = useState(0);
  const [scrollEnd, setScrollEnd] = useState(false);

  const scrollSizeLimit = isMobile ? 2 : isTablet ? 4 : 3;
  const scrollSize = isMobile ? 175 : 190;
  const isScrollStart = scroll === 0;
  const scrollable = childCount > minCount;
  const scrollLimit = (childCount - scrollSizeLimit) * scrollSize;
  const maxScroll = isMobile ? 15 : 150;

  const handleCarouselScroll = (back = false) => {
    const el = document.getElementById(sectionId);

    if (back) {
      if (!isScrollStart || (isScrollStart && isRtl)) {
        el.scrollLeft -= scrollSize;
        setScroll((prevState) => prevState - scrollSize);
      }
    } else {
      if (scroll !== scrollLimit) {
        el.scrollLeft += scrollSize;
        setScroll((prevState) => prevState + scrollSize);
      }
    }
  };

  const onScroll = () => {
    const scrollLeft = ref.current.scrollLeft;
    setScroll(scrollLeft);
  };

  useEffect(() => {
    if (el) {
      const limit = elScrollWidth - elOffsetWidth;
      const end = isRtl ? -limit : limit;
      const isEnd = elScrollLeft === end;

      setScrollEnd(isEnd);
    }
  }, [isRtl, el, elScrollLeft, elScrollWidth, elOffsetWidth]);

  const carouselContainerClassName = classNames('carousel-outer-div', {
    'carousel-show-half-of-next': showHalfOfNext,
    'carousel-outer-div-lg': isWeb,
  });

  const carouselClassName = classNames('horizontal-carousel', {
    'horizontal-carousel-lg': isWeb,
  });

  const carouselItemClassName = classNames('carousel-item-div', {
    'carousel-item-div-lg': isWeb,
  });

  return (
    <div className={carouselContainerClassName}>
      <div className={carouselClassName} id={sectionId} ref={ref} onScroll={onScroll}>
        {isWeb && !isMobile && (
          <CarouselButtons
            scroll={scroll}
            scrollLimit={scrollLimit}
            scrollable={scrollable}
            maxScroll={maxScroll}
            isDirRtl={isRtl}
            isScrollStart={isScrollStart}
            scrollEnd={scrollEnd}
            handleCarouselScroll={handleCarouselScroll}
          />
        )}
        {data?.map((dataItem) => (
          <div className={carouselItemClassName} key={Math.random()}>
            <ItemComponent data={dataItem} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FreeCarousel;
